<script>
  import { onMount } from "svelte";
  import Footer from "../components/Footer.svelte";
  import LandingHeader from "../components/LandingHeader.svelte";

  let logoContainer;

  onMount(() => {
    const scrollLogos = () => {
      logoContainer.scrollLeft += 0.5;

      if (logoContainer.scrollLeft >= logoContainer.scrollWidth / 2) {
        logoContainer.scrollLeft = 0;
      }
      requestAnimationFrame(scrollLogos);
    };
    scrollLogos();
  });

  const products = [
    {
      title: "C2PA",
      description:
        "TruLens amplifies the open C2PA standard by ensuring unmatched security, traceability, and authenticity for digital content across platforms.",
      image: "/c2pa-ai.jpg",
    },
    {
      title: "Virtual inspections",
      description:
        "Enable fast, reliable digital inspections with authenticated visual content as a cost-effective alternative to in-person audits and claims processes.",
      image: "/vi.jpg",
    },
    {
      title: "Digital Content Verification",
      description:
        "Authenticate digital content with precision using TruLens’s advanced verification technologies, assuring data integrity every time.",
      image: "/dc.jpg",
    },
    {
      title: "Secure Media Storage",
      description:
        "Protect your media assets with TruLens’s verifiable and tamper-resistant storage solutions for complete content security.",
      image: "/sm.jpg",
    },
  ];

  let selectedOption = "mediaServices";
  const options = {
    genAI: {
      title: "Verification",
      description:
        "Ensure transparency for both synthetic and original digital content, enabling secure and interoperable digital media.",
      image: "/verify.jpg",
    },
    hardware: {
      title: "Hardware",
      description:
        "Deploy cutting-edge hardware solutions to ensure content authenticity from creation, embedding transparency at the hardware level.",
      image: "/hardware.jpg",
    },
    mediaServices: {
      title: "Media Services",
      description:
        "Securely verify and share digital media across networks, enhancing interoperability and trustworthiness.",
      image: "/media-services.jpg",
    },
  };

  function selectOption(option) {
    selectedOption = option;
  }

  // const stats = [
  //  {
  //    number: "******+",
  //    description: "C2PA-compliant media files powered by TruLens",
  //  },
  //  {
  //    number: "****+",
  //    description: "authenticated events and posts using TruLens",
  //  },
  //  { number: "**+", description: "countries leveraging TruLens technology" },
  // ];
</script>

<LandingHeader />
<br /><br />
<body>
    

<section class="container">
  <div class="text-content">
    <p>Digital Media Verification Solutions</p>
    <h1>Build Trust in Every Pixel and Sound</h1>
    <p>
      TruLens empowers you to verify the source, authenticity, and context of
      digital media. Whether meeting C2PA standards or ensuring tamper-proof
      records, our secure tools safeguard truth across digital landscapes.
    </p>
  </div>
  <div class="image-content">
    <img src="/main.jpg" alt="Visual of verified inspection" />
  </div>
</section>

<section class="trusted-by">
  <h2 style="font-size: xx-large;">Trusted by Leading Organizations</h2>
  <div class="logo-container" bind:this={logoContainer}>
    <div class="logos">
      <img src="/jionex.jpg" alt="Logo 1" class="logo" />
      <img src="/Pay2Local.jpg" alt="Logo 2" class="logo" />
      <img src="/payorio.jpg" alt="Logo 3" class="logo" />
      <img src="/Tasdeeq.jpg" alt="Logo 4" class="logo" />
      <img src="/enterprise.jpg" alt="Logo 5" class="logo" />
      <!-- <img src="/saturn.jpg" alt="Logo 6" class="logo" /> -->

      <!-- Duplicate logos for seamless scrolling -->

      <img src="/jionex.jpg" alt="Logo 1" class="logo" />
      <img src="/Pay2Local.jpg" alt="Logo 2" class="logo" />
      <img src="/payorio.jpg" alt="Logo 3" class="logo" />
      <img src="/Tasdeeq.jpg" alt="Logo 4" class="logo" />
      <img src="/enterprise.jpg" alt="Logo 5" class="logo" />
      <!-- <img src="/saturn.jpg" alt="Logo 6" class="logo" /> -->

      <img src="/jionex.jpg" alt="Logo 1" class="logo" />
      <img src="/Pay2Local.jpg" alt="Logo 2" class="logo" />
      <img src="/payorio.jpg" alt="Logo 3" class="logo" />
      <img src="/Tasdeeq.jpg" alt="Logo 4" class="logo" />
      <img src="/enterprise.jpg" alt="Logo 5" class="logo" />
      <!-- <img src="/saturn.jpg" alt="Logo 6" class="logo" /> -->

      <img src="/jionex.jpg" alt="Logo 1" class="logo" />
      <img src="/Pay2Local.jpg" alt="Logo 2" class="logo" />
      <img src="/payorio.jpg" alt="Logo 3" class="logo" />
      <img src="/Tasdeeq.jpg" alt="Logo 4" class="logo" />
      <img src="/enterprise.jpg" alt="Logo 5" class="logo" />
      <!-- <img src="/saturn.jpg" alt="Logo 6" class="logo" /> -->

      <img src="/jionex.jpg" alt="Logo 1" class="logo" />
      <img src="/Pay2Local.jpg" alt="Logo 2" class="logo" />
      <img src="/payorio.jpg" alt="Logo 3" class="logo" />
      <img src="/Tasdeeq.jpg" alt="Logo 4" class="logo" />
      <img src="/enterprise.jpg" alt="Logo 5" class="logo" />
      <!-- <img src="/saturn.jpg" alt="Logo 6" class="logo" /> -->

      <img src="/jionex.jpg" alt="Logo 1" class="logo" />
      <img src="/Pay2Local.jpg" alt="Logo 2" class="logo" />
      <img src="/payorio.jpg" alt="Logo 3" class="logo" />
      <img src="/Tasdeeq.jpg" alt="Logo 4" class="logo" />
      <img src="/enterprise.jpg" alt="Logo 5" class="logo" />
      <!-- <img src="/saturn.jpg" alt="Logo 6" class="logo" /> -->
    </div>
  </div>
</section>

<section class="why-trulens">
  <h2 style="font-size: xx-large;">Why Choose TruLens?</h2>
  <p style="font-size: large; text-align: justify; margin-left: 20px;">
    As AI technologies evolve, the need for credible digital content becomes
    paramount. TruLens provides sophisticated tools to authenticate and
    safeguard digital media, ensuring it remains transparent and trustworthy in
    a world of increasing digital complexity.
  </p>
  <div class="features">
    <div class="feature">
      <img src="/user.jpg" alt="Feature 1" />
      <h3>User Authentication</h3>
      <p>
        TruLens uses cryptographic authentication for secure uploads, ensuring
        all media originates from verified users. This process strengthens trust
        and reinforces content integrity.
      </p>
    </div>
    <div class="feature">
      <img src="/media.jpg" alt="Feature 2" />
      <h3>Media Integrity</h3>
      <p>
        Our system verifies content authenticity by tracking camera lenses and
        using advanced hashing algorithms (e.g., SHA-256, C2PA) to validate
        digital media.
      </p>
    </div>
    <div class="feature">
      <img src="/folder.jpg" alt="Feature 3" />
      <h3>Controlled Media Access</h3>
      <p>
        Media is stored securely within TruLens, preventing unauthorized access
        and modification. This ensures each piece of content remains authentic
        and unaltered.
      </p>
    </div>
    <div class="feature">
      <img src="/location.jpg" alt="Feature 4" />
      <h3>Location Verification</h3>
      <p>
        TruLens verifies location data by bypassing spoofed signals and using
        location directly from the device hardware and ensuring that untrusted
        tools do not interfere with the capture process
      </p>
    </div>
    <div class="feature">
      <img src="/2fa.jpg" alt="Feature 5" />
      <h3>Commitment to Privacy and Security</h3>
      <p>
        Privacy is paramount. TruLens protects user data and media with tools
        like two-factor authentication, biometric access and advanced privacy
        controls, maintaining strict security standards.
      </p>
    </div>
    <div class="feature">
      <img src="/search.jpg" alt="Feature 6" />
      <h3>Powerful Search Tools</h3>
      <p>
        TruLens supports advanced search features, enabling precise searches by
        location, date, tags, and more, making content discovery intuitive and
        efficient.
      </p>
    </div>
  </div>
</section>

<section class="explore-products">
  <p style="font-size: xx-large;">Explore Our Solutions</p>
  <p style="font-size: xx-large; font-weight: bold;">
    Leading the Future of Content Authenticity
  </p>

  <div class="card-container">
    {#each products as product}
      <div class="card1">
        <img src={product.image} alt={product.title} />
        <div class="card-title" style="text-align: left; font-weight:bold;">
          {product.title}
        </div>
        <div class="card-description" style="text-align: left;">
          {product.description}
        </div>
      </div>
    {/each}
  </div>
</section>

<section class="where-we-fit">
  <div class="card">
    <h2 style="font-size: xx-large;">Our Perfect Fit</h2>
    <p style="font-size: x-large;">
      Customized Content Verification for Every Industry
    </p>
    <p class="description" style="text-align: justify;">
      TruLens offers digital media solutions across industries like insurance,
      finance, and media. Our secure C2PA and TruLens Vision solutions provide
      customized verification, enhancing transparency and protecting against
      fraud.
    </p>

    <div>
      {#each Object.keys(options) as option}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
          class="tab {selectedOption === option ? 'selected' : ''}"
          on:click={() => selectOption(option)}
        >
          {options[option].title}
        </div>
      {/each}
    </div>

    <div class="info-section">
      <img
        class="info-image"
        src={options[selectedOption].image}
        alt={options[selectedOption].title}
      />
      <div>
        <div class="info-title" style="font-weight: bold;">
          {options[selectedOption].title}
        </div>
        <div class="info-description">
          {options[selectedOption].description}
        </div>
      </div>
    </div>
  </div>
</section>

<section class="technology-section">
  <div class="left-side">
    <div class="heading">Our Technology</div>
    <div class="heading" style="font-weight: bold;">
      Empowering a Transparent Digital World
    </div>
  </div>

  <div class="right-side">
    <div class="description">
      At TruLens, our vision is to secure the authenticity of every digital
      interaction. Through our advanced tools and C2PA integration, we embed
      transparency across the media lifecycle, ensuring content remains
      verifiable and trustworthy.
    </div>
  </div>
</section>

<!-- <div class="stats-container">
  {#each stats as stat}
    <div class="stat">
      <div class="stat-number">{stat.number}</div>
      <div class="stat-description">{stat.description}</div>
    </div>
  {/each}
</div> -->

</body>

<br /><br />

<Footer />

<style>
  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden; /* Prevents horizontal scrolling */
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 2rem; /* Adjusted padding for uniformity */
    padding-right: 0;
    background-color: #f3f4f6;
    color: #333;
    width: 90%;
    margin: auto; /* Centers the container */
    border-radius: 15px; /* Adjust the radius as needed */
    flex-wrap: wrap; /* Allow content to wrap on smaller screens */
  }

  .text-content {
    flex: 1;
    max-width: 100%;
    padding: 1rem;
  }

  .text-content h1 {
    font-size: 2rem;
    font-weight: bold;
    color: #1a1a1a;
  }

  .text-content p {
    font-size: 1.2rem;
    margin-top: 1rem;
    color: #555;
  }

  .image-content {
    flex: 1;
    max-width: 100%;
    display: flex;
    justify-content: center;
  }

  .image-content img {
    width: 100%;
    max-width: 550px;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .trusted-by {
    padding: 3rem 1rem;
    background-color: #ffffff;
    text-align: center;
    overflow: hidden;
  }

  .trusted-by h2 {
    color: #333;
    margin-bottom: 1rem;
    /* animation: fadeIn 2s forwards; */
  }

  .logo-container {
    display: flex;
    overflow: hidden;
    position: relative;
  }

  .logos {
    display: flex;
    gap: 9rem;
    white-space: nowrap;
    animation: scroll 40s linear infinite; /* Adjust speed as needed */
  }

  .logo {
    flex: 0 0 auto;
    width: 100px;
    height: auto;
  }

  .explore-products .card-container {
    display: flex;
    flex-wrap: wrap; /* Enable wrapping of cards */
    justify-content: center;
    gap: 1rem;
    /* padding: 2rem 0; */
  }

  .explore-products {
    padding: 2rem;
  }

  .where-we-fit {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3rem 1rem;
    text-align: center;
  }

  @keyframes scroll {
    from {
      transform: translateX(0); /* Start from the first logo */
    }
    to {
      transform: translateX(-50%); /* Move to the middle (end of first set) */
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .why-trulens {
    padding: 2rem;
    background-color: #f3f4f6;
    text-align: center;
    width: 90%;
    margin: auto; /* Centers the container */
    border-radius: 15px; /* Adjust the radius as needed */
  }

  .why-trulens h2 {
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }

  .features {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2rem;
  }

  .feature {
    background: #f9f9f9;
    border-radius: 8px;
    padding: 1.5rem;
    width: 300px;
    text-align: left;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .feature img {
    max-width: 100%;
    margin-bottom: 1rem;
  }

  .feature h3 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .feature p {
    font-size: 1rem;
    color: #666;
  }

  .description {
    font-size: 1rem;
    color: #666;
    margin-top: 0.5rem;
  }

  .card {
    display: inline-block;
    flex-direction: column;
    align-items: center;
    background: #f9f9f9;
    border-radius: 8px;
    padding: 1rem 1rem;
    text-align: center;
    cursor: pointer;
    max-width: 100%;
    margin: 0 auto;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .tab {
    display: inline-block;
    padding: 0.5rem 1rem;
    margin: 0 0.5rem;
    border: 1px solid #007bff;
    border-radius: 5px;
    cursor: pointer;
    background-color: white;
    transition:
      background-color 0.3s ease,
      transform 0.2s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  .tab:hover {
    background-color: #accfff; /* Light blue on hover */
    transform: translateY(-2px); /* Slight lift effect on hover */
  }

  .tab.selected {
    background-color: #007bff;
    color: white;
    box-shadow: 0 4px 10px rgba(0, 123, 255, 0.4); /* Enhanced shadow for selected tab */
    transform: scale(1.05); /* Slightly enlarge the selected tab */
  }

  .info-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 3rem;
    background-color: #ffffff;
    margin-top: 1rem;
  }

  .info-image {
    max-width: 250px; /* Adjust as needed */
    margin-right: 1.5rem;
  }

  .info-title {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    margin-top: 1rem;
  }

  .info-description {
    font-size: 1rem;
    color: #666;
  }

  .card-container {
    display: flex;
    flex-wrap: wrap; /* Allows the cards to wrap to the next line */
    justify-content: center; /* Centers the cards horizontally */
    gap: 2rem; /* Space between cards */
  }

  .card1 {
    flex: 1 1 200px; /* Make cards responsive */
    max-width: 100%;
    text-align: center;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .card1 img {
    max-width: 100%;
    border-radius: 8px 8px 0 0;
  }

  .card-title {
    font-size: 1.2rem;
    margin: 1rem 0 0.5rem;
    padding: 0.5rem 1rem;
  }

  .card-description {
    font-size: 1rem;
    color: #666;
    padding: 0.5rem 1rem 0.5rem;
  }

  .technology-section {
    display: flex;
    padding: 2rem;
    background-color: #ffffff;
    border-bottom: 1px solid #eaeaea;
  }

  .left-side {
    flex: 1;
    padding-right: 2rem;
  }

  .right-side {
    flex: 1;
    border-left: 2px solid #eaeaea; /* Line dividing left and right */
    padding-left: 2rem;
  }

  .heading {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  .description {
    font-size: 1rem;
    color: #666;
    margin-bottom: 1.5rem;
  }

  .explore-link {
    color: #007bff;
    text-decoration: underline;
    cursor: pointer;
    margin-bottom: 2rem;
  }

  /* .stats-container { */
    /* display: flex; */
    /* justify-content: space-around; Distributes space evenly around stats */
    /* margin-top: 2rem; */
    /* padding: 1rem; Optional padding around the stats */
  /* } */

  /* .stat { */
    /* text-align: center; */
    /* flex: 1; Each stat will take up equal space */
    /* margin: 0 1rem; Add margin for spacing between stats */
    /* min-width: 120px; Ensures a minimum width for better layout */
  /* } */

  .stat-number {
    font-size: 2rem;
    font-weight: bold;
  }

  .stat-description {
    margin-bottom: 25px;
    font-size: 0.9rem;
    color: #666;
  }

  .where-we-fit .tab {
    display: inline-block;
    padding: 0.2rem 0.4rem; /* Reduce padding for smaller buttons */
    font-size: 1rem; /* Adjust font size to make buttons smaller */
    width: 29%; /* Ensures 3 buttons can fit side by side */
    text-align: center;
  }

  /* Media Queries */
  @media (max-width: 768px) {
    .container {
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding-right: 0;
      padding-left: 0;
      width: 90%;
    }

    .text-content h1 {
      font-size: 1.8rem;
    }

    .explore-products {
      padding: 2rem;
    }

    .explore-products .card-container {
      flex-direction: column;
      align-items: center;
    }

    .where-we-fit {
      padding: 2rem 0;
    }

    .where-we-fit .tab {
      padding: 0.2rem 0.4rem;
      font-size: 1rem; /* Slightly reduce font size for smaller screens */
      width: 29%; /* Ensure buttons fit side by side in one row */
    }
    .image-content img {
      width: 100%;
      max-width: 550px;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-left-radius: 15px;
      border-bottom-right-radius: 15px;
    }
  }

  @media (max-width: 480px) {
    .text-content h1 {
      font-size: 1.6rem;
    }

    .logo-container {
      gap: 4rem;
    }

    .card1 {
      flex: 1 1 auto;
      width: 100%;
    }

    .tab {
      font-size: 0.9rem;
    }

    .where-we-fit .tab {
      padding: 0.2rem 0.4rem;
      font-size: 0.8rem; /* Slightly reduce font size for smaller screens */
      width: 25%; /* Ensure buttons fit side by side in one row */
    }

    .info-title {
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
      margin-top: 1rem;
    }

    .technology-section {
      padding: 1rem;
    }
  }

  @media (max-width: 390px) {
    .container,
    .text-content,
    .where-we-fit .tab {
      width: 100%; /* Ensure full-width on smaller screens */
      text-align: center; /* Center-align text and buttons */
    }

    .container{
      width: 90%; /* Ensure full-width on smaller screens */
      text-align: center; /* Center-align text and buttons */
    }

    .where-we-fit .tab {
      padding: 0.2rem 0.4rem;
      font-size: 0.6rem; /* Slightly reduce font size for smaller screens */
      width: 26%; /* Ensure buttons fit side by side in one row */
    }

    /* Center-align images if necessary */
    .image-content img {
      display: block;
      margin: auto; /* Centers images horizontally */
      max-width: 100%;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-left-radius: 15px;
      border-bottom-right-radius: 15px;
    }
    .stat-number {
    font-size: 1.3rem;
  }

  .stat-description {
    font-size: 0.75rem;
  }

  .stat {
    width: 100%; /* Full width on very small screens */
    margin: 0.5rem 0;
  }
  }
</style>
